




































import { Component, Vue, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import { translateCriteria, formattedAgeRange, formattedGeographicLocation } from '@/utilities/audience-mappers'
import TaggedCard from './TaggedCard.vue'
import Criteria from './Criteria.vue'

const MAIN_CRITERIA = ['Age', 'International', 'State']

@Component({
  components: {
    TaggedCard,
    Criteria
  }
})
export default class DefaultDraftAudienceInfo extends Vue {
  @Prop({ required: true }) readonly audience!: Partial<db.Audience>
  @Prop({ required: false }) readonly tag?: string | null

  get translatedCriteria () {
    return translateCriteria(this.audience.criteria || {})
  }

  get age (): string {
    return formattedAgeRange(this.audience)
  }

  get location (): string {
    return formattedGeographicLocation(this.audience)
  }

  get otherCriteria () {
    return this.translatedCriteria.filter(crit => !MAIN_CRITERIA.includes(crit.name))
  }
}
